
export class Location {
    Latitude: number;
    Longitude: number;
}

export class LookUp {
    Id: any;
    UniqueKey: string;
    DisplayName: string;
    IsDeleted: boolean;
    ExtraFields: any;
    Value: any;
    LookupObjectType: LookupObjectType;
}

export class LookUpNode extends LookUp {
    LookupNodes: LookUp[] = [];
    hasChildren: boolean = false;
}

export class WriteLookup {
    Id: number;
    UniqueKey: string;
    EnglishName: string;
    ArabicName: string;
    IsDeleted: boolean;
    LookupObjectType: LookupObjectType;
    ForeignColumnName: string;
    ForeignKeyValue: string;
}

export enum LookUpTableName {
    VehicleCapacityUnit,
    VehicleColor,
    VehicleBrand,
    VehicleGroup,
    CourierType,
    VehicleManufacturer,
    SensorType,
    DigitalValue,
    DigitalValueName,
    Unit,
    VehicleType,
    POIType,
    SimCardProvider,
    DeviceModel,
    DeviceType,
    MainSensorType,
    Language,

    RuleParameters,
    TimeZone,
    Country,
    Currency,
    NotificationChannel,
    AdminNotificationCategory,

    PMPPriority,
    PMPCategory,
    PMPRepairType,
    MaintenanceWorkOrderStatus,
    RFRStatus,
    RFRType,
    RepairsStatus,
    CancellationReason,
    SensorUnit,
    OrderStatus,
    POIStatus,
    WorkOrderStatus,
    PaymentMethod,
    NotDeliveredReason,
    ActionLogType,
    StaffType,

    ResourceDeliveryType,
    ThreePLServiceProvider, 
    City
}

export enum LookupObjectType {
    System,
    Subscriber
}

export enum DBSchema {
    dbo,
    Core
}

export enum ReferenceModelEnum {
    //SubscriberAdmin = 1,
    //Driver = 4,
    //Parent = 5,
    RootAdmin = 1,
    SystemAdmin = 2,
    SubscriberAdmin = 3,
    GeneralManager = 4,
    OperationManager = 5,
    OperationAssistantManager = 6,
    MaintenaceManager = 7,
    InventoryManager = 8,
    Vendor = 9,
    FinancialManager = 10,
    Accountant = 11,
    HRManager = 12,
    MechanicalEngineer = 13,
    ElectricalEngineer = 14,
    DataEntry = 15,
    QualityControl = 16,
    Tracker = 17,
    Supervisor = 18,
    DriverSupervisor = 19,
    ClassADriver = 20,
    ClassBDriver = 21,
    ClassCDriver = 22,
    //FleetManager= 4,
    //BranchManager= 5,
    //SeniorManagment= 6,
    //Planner= 7,
    //Operator= 8,
    //WorkOrderViewer= 9,
    //Driver= 10,
    //OperationAdmin = 11,
    //OperatorPlanner = 12,

}

export class DescriptiveResponse<T> {
    Value: T;
    IsErrorState: boolean;
    ErrorMetadata: any;
    ErrorDescription: string;
}

export class Symbol {
    UniqueName: string;
    LayerName: string;
    Properties: any;
}

export class LineShape {
    LineGeometry: string;
}

export class DirectionsServiceRequestObject {
    source: string;
    destination: string;
    waypoints: string;
    mode: string = "driving";
    language: string = "en";
}

export enum ConfigurationKeyEnum {
    MapProvider = 1,
    AllowedFileTypes = 2,
    MaxFileSize = 3,
    TimeZone = 4,
    DefaultZoom = 5,
    DefaultLatitude = 6,
    DefaultLongitude = 7,
    LogisticsServiceSubmitJobURL = 8,
    LogisticsServiceOutputResultURl = 10,
    ClientId = 12,
    ClientSecret = 13,
    MapUrl = 14,
    PoIZoomLevel = 15,
    VehicleZoomLevel = 16,
    MinZoomLevel = 17,
    MaxZoomLevel = 18,
    TimeRegion = 19,
    CalculatedPoint = 20,
    CalculatedPerioud = 21,
    IsNormalized = 22,
    NormalizedDistance = 23,
    TravelTime = 24,
    AllowedDelay = 25,
    DayLight = 26,
    DayNight = 27,
    VehiclesLimit = 28,
    UsersLimit = 29,
    GeofenceLimit = 30,
    POILimit = 31,
    Voucher = 32,
    PreventDriverFromEndingWO = 33,
    IsForceApprovmentRequired = 42,
    AllowDriverEndWO=43
}

export enum CookiesEnum {
    UserPreference
}

export class ChartSpecification {
    divId: string;
    title: string;
    data: any[];
    value: string;
}

export class BarChartSpecification extends ChartSpecification {
    yAxis: string;
    balloonText: string;
    graphTitle: string;
    valueAxisTitle: string;
    barCount: number;
    perProperty: string;
}

export class MultiBarChartSpecification extends ChartSpecification {
    perProperty: string;
    yAxis: string;
    xAxis: string;
    barCount: number;
}

export class LineChartSpecification extends ChartSpecification {
    xAxis: string;
    perYAxisValue: string;
    perTotalYAxisValue: string;
    countProperty: string;
}

export class MultiLineChartSpecification extends LineChartSpecification {
    yAxis: string;

}

export class ScatterChartSpecification extends MultiLineChartSpecification {
    groupBy: string;
    xAxisTitle: string;
    yAxisTitle: string;
}

export class InfoGraphic {
    data: any[];
    title: string;
    value: string;
    perValue: string;
    groupProperty: string;
    countProperty: string;
    perTotalValue: string;
}
export enum ResourceTypeEnum {
    InHouse = 1,
    ThreePL=2,
    Freelance=3
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/data-models.ts